import { render, staticRenderFns } from "./EachVolunteer.vue?vue&type=template&id=c0460ad2&scoped=true"
import script from "./EachVolunteer.vue?vue&type=script&lang=js"
export * from "./EachVolunteer.vue?vue&type=script&lang=js"
import style0 from "./EachVolunteer.vue?vue&type=style&index=0&id=c0460ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0460ad2",
  null
  
)

export default component.exports